import React from 'react';
import { CalendarCheckIcon, ClipboardListIcon, HardHatIcon, MessageSquareIcon, SearchCheckIcon, ThumbsUpIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { processSteps } from '../data/process';
import { ui } from '../data/translations';
const stepIcons = [MessageSquareIcon, ClipboardListIcon, CalendarCheckIcon, HardHatIcon, SearchCheckIcon, ThumbsUpIcon];
export function Process() {
  const {
    t
  } = useLanguage();
  return <section id="process" className="w-full bg-mist py-20 lg:py-28" data-id="element-175" data-mp="1apct78e9mfvb">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-176" data-mp="1anjmjt3njvnb">
        <div className="max-w-2xl" data-id="element-177" data-mp="1fno3tlcdwuel">
          <h2 className="font-display text-3xl font-bold leading-tight text-navy lg:text-4xl" data-id="element-178" data-mp="1fne8di8klv1i">{t(ui.process.title)}</h2>
          <p className="mt-4 text-steel" data-id="element-179" data-mp="n01ojftso1bw">{t(ui.process.subtitle)}</p>
        </div>

        <ol className="mt-14 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-180" data-mp="mxyzay0guc88">
          {processSteps.map((step, i) => {
          const Icon = stepIcons[i];
          return <li key={step.title.en} data-id="element-181" data-mp="19kfxaw7iqstf" data-mpi={i}>
                <div className="flex items-center gap-4" data-id="element-182" data-mp="15jvzrrj19n6r">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xl font-bold text-gold" data-id="element-183" data-mp="15kfivbkf6hmd">
                    {i + 1}
                  </span>
                  <span aria-hidden="true" className="h-px flex-1 bg-navy/15" data-id="element-184" data-mp="vrqdmyfgpzzh" />
                  <Icon className="h-6 w-6 text-steel" aria-hidden="true" data-id="element-185" data-mp="qwaze5djm22j" />
                </div>
                <h3 className="mt-6 font-display text-xl font-semibold text-navy" data-id="element-186" data-mp="lu3j53lojzue">{t(step.title)}</h3>
                <p className="mt-2 text-steel" data-id="element-187" data-mp="hul8d0nkp55a">{t(step.description)}</p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}